(function () {
    const checkoutButton = document.querySelector('.cart__checkout-button');
    const stickycheckoutButton = document.querySelector('.sticky_container');


        // Создаем наблюдатель
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
            if (!entry.isIntersecting) {
                // Если элемент не виден, добавляем класс active
                stickycheckoutButton.classList.add('active');
            } else {
                // Если элемент виден, убираем класс active
                stickycheckoutButton.classList.remove('active');
            }
            });
        });


        // Начинаем наблюдение за основным элементом
        if (checkoutButton) {
            observer.observe(checkoutButton);
        }

        // CRO: przycisk zawsze aktywny; bez zaznaczonego checkboxa pokazujemy
        // stan błędu (podświetlenie + komunikat) zamiast blokować przycisk
        const termsCheckbox = document.getElementById("newsletter-checkbox");
        const termsContainer = termsCheckbox ? termsCheckbox.closest('.checkbox-container') : null;
        const termsMessage = document.querySelector('.message_text');

        function clearTermsError() {
            if (termsContainer) termsContainer.classList.remove('checkbox-container--error');
            if (termsMessage) termsMessage.classList.add('hidden');
        }

        function showTermsError() {
            if (termsContainer) {
                termsContainer.classList.add('checkbox-container--error');
                termsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            if (termsMessage) termsMessage.classList.remove('hidden');
        }

        if (termsCheckbox) {
            termsCheckbox.addEventListener('change', function () {
                if (this.checked) clearTermsError();
            });
        }

        if (checkoutButton) {
            checkoutButton.addEventListener('click', function (e) {
                if (termsCheckbox && !termsCheckbox.checked) {
                    e.preventDefault();
                    showTermsError();
                }
            });
        }
  })();

(function () {
    const stickycheckoutButton = document.querySelector('.sticky_add_to_cart');
    if (!stickycheckoutButton) return;

    stickycheckoutButton.addEventListener('click', function () {
        const target = document.querySelector('.cart__footer .cart__blocks_inner');
        if (target ) {
            const rect = target.getBoundingClientRect();
            const offset = window.pageYOffset + rect.top - 300; // -300 пикселей вверх
            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        }
    });
})();
